// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles__grid___1eTzZ","title":"styles__title___3LMq4","subtitle":"styles__subtitle___1M-ii"};